// extracted by mini-css-extract-plugin
module.exports = {"root":"segments-segment_root___DS1s","cardContent":"segments-segment_cardContent__mm00V","table":"segments-segment_table__aBX0b","cardRoot":"segments-segment_cardRoot__4Wx63"};